module.exports = __webpack_public_path__ + "77da481c16122750344c82914d062666.png";